// extracted by mini-css-extract-plugin
export default {"infoBlock":"InfoBlock_infoBlock__WK-KO","infoBlockInner":"InfoBlock_infoBlockInner__JX1yt"};